  import axios from "axios";
  import React, { useEffect, useState } from "react";
  import { Link, useNavigate } from "react-router-dom";

  function ViewConvenioSempapel() {
    const [data, setData] = useState([]);
    const [isAdmin, setIsAdmin] = useState(false);
    const [searchTerm, setSearchTerm] = useState("");
    const navigate = useNavigate();

    const formatBRL = (value) => {
      if (value === null || value === undefined || value === "") return "-";
      const num = Number(value);
      if (isNaN(num)) return "-";

      return num.toLocaleString("pt-BR", {
        style: "currency",
        currency: "BRL",
      });
    };

    const carregarDados = () => {
      axios
        .get("/api/conveniossempapel")
        .then((res) => {
          setData(res.data);
        })
        .catch((err) => {
          console.error("Erro ao carregar dados:", err);
          alert("Erro ao carregar dados do servidor");
        });
    };

    useEffect(() => {
      const userRole = localStorage.getItem("UserRole");
      setIsAdmin(userRole === "admin");
      carregarDados();
    }, []);

    const handleDelete = (id) => {
      if (window.confirm("Tem certeza que deseja deletar este convênio?")) {
        axios
          .delete(`/api/conveniossempapel/${id}`)
          .then((res) => {
            if (res.data.message === "Convenio deletado com sucesso!") {
              alert("Convênio deletado!");
              carregarDados();
            } else {
              alert("Erro ao deletar o convênio");
            }
          })
          .catch((err) => {
            console.error(err);
            alert("Erro no servidor");
          });
      }
    };

    return (
      <div className="fs-11 px-18 py-8" style={{ overflow: "visible" }}>
        <div className="d-flex justify-content-center mb-3">
          <h3>Convênios SEMPAPEL</h3>
        </div>

        <div className="mb-3 d-flex align-items-center gap-2 flex-wrap">
          {isAdmin && (
            <Link to="/addconveniossempapel" className="btn btn-primary">
              + Novo Convênio
            </Link>
          )}
          <Link to="/conveniosfinisa" className="btn btn-secondary">Convênios FINISA</Link>
          <Link to="/conveniosfederal" className="btn btn-secondary">Convênios FEDERAL</Link>
          <Link to="/conveniosestadual" className="btn btn-secondary">Convênios ESTADUAL</Link>
          <Link to="/conveniosdade" className="btn btn-secondary">Convênios DADE</Link>

          <input
            type="text"
            placeholder="Buscar por Objeto, Empresa, Contrato..."
            className="form-control"
            style={{ maxWidth: "300px" }}
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>

        <div style={{ overflowX: "auto" }}>
          <table className="table table-responsive table-bordered table-hover">
            <thead className="table-success">
              <tr>
                <th>ID</th>
                <th>Objeto</th>
                <th>Objeto Completo</th>
                <th>Parlamentar</th>
                <th>CP/DL/TP</th>
                <th>Contrato</th>
                <th>Nº Convênio</th>
                <th>Nº Demanda</th>
                <th>Ano</th>
                <th>Repasse Convênio (R$)</th>
                <th>Contrapartida Convênio (R$)</th>
                <th>Assinatura Termo</th>
                <th>Vigência Convênio</th>
                <th>Vigência Contrato</th>
                {isAdmin && <th>Ações</th>}
              </tr>
            </thead>

            <tbody>
              {data
                .filter((item) => {
                  const search = searchTerm.toLowerCase();
                  return (
                    item.objeto?.toLowerCase().includes(search) ||
                    item.objeto_completo?.toLowerCase().includes(search) ||
                    item.contrato?.toLowerCase().includes(search) ||
                    item.numero_convenio?.toString().includes(search) ||
                    item.numero_demanda?.toString().includes(search) ||
                    item.ano?.toString().includes(search) ||
                    item.parlamentar?.toLowerCase().includes(search)
                  );
                })
                .map((item, index) => (
                  <tr key={index}>
                    <td>{item.id}</td>
                    <td>{item.objeto}</td>
                    <td>{item.objeto_completo}</td>
                    <td>{item.parlamentar}</td>
                    <td>{item.cp_dl_tp}</td>
                    <td>{item.contrato}</td>
                    <td>{item.numero_convenio}</td>
                    <td>{item.numero_demanda}</td>
                    <td>{item.ano}</td>
                    <td>{formatBRL(item.repasse_convenio)}</td>
                    <td>{formatBRL(item.contra_convenio)}</td>
                    <td>{item.ass_termo}</td>
                    <td>{item.vigencia_convenio}</td>
                    <td>{item.vigencia_contrato}</td>
                    {isAdmin && (
                      <td>
                        <button
                          className="btn btn-light btn-sm me-2"
                          onClick={() => navigate(`/editconveniossempapel/${item.id}`)}
                        >
                          Editar
                        </button>

                        <button
                          className="btn btn-info btn-sm"
                          onClick={() => handleDelete(item.id)}
                        >
                          Deletar
                        </button>
                      </td>
                    )}
                  </tr>
                ))}
            </tbody>
          </table>
        </div>
      </div>
    );
  }

  export default ViewConvenioSempapel;
